import { useTranslation } from 'react-i18next'

import { useUserData } from '../../../../hooks'
import { isStaffUser } from '../../../../utils/user'
import { ProfileCreatedWidget } from '../../../Widget'

function UserProfileWidgetCreated({ isSkeleton, userData }) {
  const { t } = useTranslation()

  const currentUser = useUserData()

  const isStaffViewer = isStaffUser(currentUser)

  return (
    <ProfileCreatedWidget
      contentProps={{
        canViewCreatedBy: isStaffViewer,
        canViewUpdatedBy: isStaffViewer,
        createdAt: userData?.createdAt,
        createdBy: userData?.createdBy,
        updatedAt: userData?.updatedAt,
        updatedBy: userData?.updatedBy,
      }}
      isSkeleton={isSkeleton}
      title={t('Widget.CreatedTitleKey')}
    />
  )
}

export default UserProfileWidgetCreated
